<template>
	<div>
		<Header :logged="logged" :home="false" />
		<modalcancelamentodetalhe :nrPedidoCancelamento="nrPedidoSelecionado" :cancelamentoDados="cancelamentoDetalheSelecionada" @resposta="respConfirm" />
		<div class="content-container">
			<div class="row">
				<div class="col-12">
					<h3 class="text-primary">Meu carrinho</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-9">
					<table class="table">
						<thead>
							<tr>
								<th>Pedido</th>
								<th>Tipo pedido</th>
								<th>Orçamento</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="i in itemsCart">
								<td @click="exibir(i)">{{ i.cd_pedido }}</td>
								<td>
									{{ i.descricao }}
								</td>
								<td>{{ currencyFormatter.format(i.valor) }}</td>
								<td width="110">
									<a>
										<font-awesome-icon icon="trash" @click="remove(i.cd_pedido)" style="cursor: pointer;"/>
									</a>&nbsp;
									<a>
										<font-awesome-icon icon="eye" @click="exibir(i)" style="cursor: pointer;"/>
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-3 card">
					<div class="row">
						<div class="col-12 text-center">
							<h4 class="text-primary">Resumo</h4>
						</div>
						<div class="col-12">
							<div class="row">
								<div class="col-9">
									<h6>Quantidade de produtos: </h6>
								</div>
								<div class="col-3">{{ counter }}</div>
							</div>
							<br>
							<div class="row">
								<div class="col-8">
									<h6>Total: </h6>
								</div>
								<div class="col-4">{{ currencyFormatter.format($store.state.cart.subtotal) }}</div>
							</div>
							<br>
							<hr>
							<div class="row">
								<div class="col-6">
									
								</div>
								<div class="col-6">
									<button class="btn btn-primary btn-block" @click="closeOrder()">Fechar pedido</button>
								</div>
							</div>
							<div class="row">
								<div class="col-12">&nbsp;</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../components/Header'
	import modalprotestodetalhe from "@/components/modal/protesto_detalhe";
	import modalcertidaodetalhe from "@/components/modal/certidao_detalhe";
	import modalcancelamentodetalhe from "@/components/modal/cancelamento_detalhe";
	import modalanuenciadetalhe from "@/components/modal/anuencia_detalhe";
	import API from '../services/api'
	export default {
		components: {
			Header,
			modalprotestodetalhe,
		    modalcertidaodetalhe,
		    modalcancelamentodetalhe,
		    modalanuenciadetalhe,
		},
		data() {
			return {
				logged: true,
				currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
				cancelamentoDetalheSelecionada: {},
				nrPedidoSelecionado: null,
				exibirDetalhe: false,
				token: null,
			}
		},
		mounted(){
			this.$root
				.isLogged()
				.then(() => {
				this.logged = true;
				})
				.catch(() => {
				this.logged = false;
				});
		},
		created() {
			this.token = localStorage.getItem('jwtToken');
		},
		computed: {
			counter() {
				return this.$store.state.cart.item.length;
			},
			itemsCart() {
				return this.$store.state.cart.item;
			},
		},
		methods: {
			exibir(row) {
				var token = this.token;
				API.get(`certidao/usuario?token=${token}&dini=&dfim=&dtSoli=&nmpesq=&docp=&st=&tpPedido=3&nrPedido=${row.cd_pedido}&vl_titulo=&vl_saldo=&primeiraBusca=false`).then((res) => {
					this.nrPedidoSelecionado = row.cd_pedido;
			      	this.cancelamentoDetalheSelecionada = res.data[0]
			      	this.$bvModal.show("modal-cancelamento-detalhe");
			    })
			},
			respConfirm(res){
				if (res.respostaFinal == "s") {
					this.$bvModal.hide("modal-cancelamento-detalhe");
					this.exibirDetalhe = false;
				}
		   },
		   remove(id) {
		   	this.$dialog.confirm('Tem certeza que deseja exluir?').then(() => {
		   		this.$store.commit('cart/remove', id);
		   	})
		   },
		   closeOrder() {
		   	var token = this.token;
		   	var self = this;
		   	this.$dialog.confirm('Tem certeza que deseja concluir o pedido?').then(function() {
		   		API.post(`carrinho`, {token: token, data: self.itemsCart }).then((res) => {
		   			self.$router.push({path: `/checkout/${res.data.keycode}`});
		   			self.$store.commit('cart/clear');
		   		});
		   	});
		   }
		},
	}
	
</script>
